const API_BASE_URL = process.env.REACT_APP_API_URL;

const defaultHeaders = {
  'Content-Type': 'application/json',
};

async function request(path, options = {}) {
  const url = `${API_BASE_URL}${path}`;
  const { method = 'GET', body, headers, ...rest } = options;

  const config = {
    method,
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    credentials: 'include',
    ...rest,
  };

  if (body instanceof FormData) {
    delete config.headers['Content-Type'];
    config.body = body;
  } else if (body !== undefined) {
    config.body = JSON.stringify(body);
  }

  const response = await fetch(url, config);
  const text = await response.text();

  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (e) {
      data = text;
    }
  }

  if (!response.ok) {
    const message = data && typeof data === 'object' && data.message
      ? data.message
      : `Request failed with status ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.data = data;
    throw error;
  }

  return data;
}

function get(path, options) {
  return request(path, { ...options, method: 'GET' });
}

function post(path, body, options) {
  return request(path, { ...options, method: 'POST', body });
}

function put(path, body, options) {
  return request(path, { ...options, method: 'PUT', body });
}

function del(path, options) {
  return request(path, { ...options, method: 'DELETE' });
}

export { API_BASE_URL, request, get, post, put, del };
